<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <ng-container *ngFor="let option of data.options">
    <h3>{{ option.label }}</h3>
    <p>{{ option.tooltip }}</p>
  </ng-container>
</div>
